document.addEventListener("DOMContentLoaded", function () {
  const areas = document.querySelectorAll(".js-header-area");
  const mainHeader = document.querySelector('sticky-header');
  if (!mainHeader) return;

  let lastScrollY = window.scrollY; // 前回のスクロール位置を保存

  function toggleHeaders() {
    const scrollY = window.scrollY;
    let anyAreaVisible = false;

    areas.forEach(area => {
      const header = area.querySelector(".js-header");
      if (!header) return;

      const areaTop = area.offsetTop;
      const areaBottom = areaTop + area.offsetHeight;

      const isVisible = scrollY + 1 >= areaTop && scrollY < areaBottom;

      // 上にスクロールした場合は強制的に hidden にする
      if (scrollY < lastScrollY) {
        header.classList.remove("is-active");
        header.classList.add("is-hidden"); // hiddenを追加
      } else if (isVisible) {
        // 下にスクロールした場合、エリア内にあれば active
        header.classList.add("is-active");
        header.classList.remove("is-hidden");
        anyAreaVisible = true;
      } else {
        header.classList.remove("is-active");
        header.classList.add("is-hidden");
      }
    });

    // ループ後に mainHeader の表示制御
    if (anyAreaVisible) {
      mainHeader.classList.add("is-hidden");
    } else {
      mainHeader.classList.remove("is-hidden");
    }
    // スクロール方向の判定
    lastScrollY = scrollY;
  }

  window.addEventListener("scroll", toggleHeaders);
  window.addEventListener("resize", toggleHeaders);
  toggleHeaders(); // 初期チェック
});
